export const CONFIRMED_GET_CAMPAIGNS = "CONFIRMED_GET_CAMPAIGNS";
export const CONFIRMED_CREATE_CAMPAIGN = "CONFIRMED_CREATE_CAMPAIGN";
export const CONFIRMED_DELETE_CAMPAIGN = "CONFIRMED_DELETE_CAMPAIGN";
export const CONFIRMED_EDIT_CAMPAIGN = "CONFIRMED_EDIT_CAMPAIGN";
export const CONFIRMED_GET_CAMPAIGNS_BY_DATE =
  "CONFIRMED_GET_CAMPAIGNS_BY_DATE";
